import { BaseLkApiAuth } from '@/api/BaseApiAuth'
import { Report as Data, ReportCollection as Collection } from '@/typings/api/LkGeneralReport'

export class LkReportsApi extends BaseLkApiAuth<Data, Collection> {
    protected readonly endpoint = 'reports';

    public getDownloadUrl(reportId: number) {
      const path = `/${reportId}/download`
      const [url] = this.getUrl(path)
      return url
    }
}
